import { render } from "./NoChannels.vue?vue&type=template&id=2850fa36&scoped=true&ts=true"
import script from "./NoChannels.vue?vue&type=script&lang=ts"
export * from "./NoChannels.vue?vue&type=script&lang=ts"

import "./NoChannels.vue?vue&type=style&index=0&id=2850fa36&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2850fa36"],['__file',"src/components/transact/NoChannels.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2850fa36"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2850fa36', __exports__)) {
    api.reload('2850fa36', __exports__)
  }
  
  module.hot.accept("./NoChannels.vue?vue&type=template&id=2850fa36&scoped=true&ts=true", () => {
    api.rerender('2850fa36', render)
  })

}


export default __exports__